import { startCase, toLower } from "lodash";

import { ParticipantTypes } from "@api/graphql";

export const participantOptionsMap = {
  resaleReporterAndRoyaltyRecipient: {
    options: [
      {
        id: "art-centre",
        label: "As an art centre",
        description: "",
        participantType: ParticipantTypes.ART_CENTRE,
      },
      {
        id: "CMO",
        label: "As a CMO",
        description: "",
        participantType: ParticipantTypes.CMO,
      },
      {
        id: "agent",
        label: "As an agent",
        description: "",
        participantType: ParticipantTypes.AGENT,
      },
    ],
    headerTitle: "I'm here to report & collect royalties",
  },
  resaleReporter: {
    options: [
      {
        id: "art-market-professional",
        label: "As an art market professional",
        description: "Art market professionals cover auction houses, art sellers, art buyers, art consultants etc.",
        participantType: ParticipantTypes.AMP,
      },
      {
        id: "art-centre",
        label: "As an art centre",
        description: "",
        participantType: ParticipantTypes.ART_CENTRE,
      },
    ],
    headerTitle: "I'm here to report royalties",
  },
  royaltyRecipient: {
    options: [
      {
        id: "artist",
        label: "As an artist",
        description: "I am collecting royalties for my own work",
        participantType: ParticipantTypes.ARTIST,
      },
      {
        id: "beneficiary",
        label: "As a beneficiary",
        description: "I am legally designated to receive an artist's royalties",
        participantType: ParticipantTypes.BENEFICIARY,
      },
      {
        id: "art-centre",
        label: "As an art centre",
        description: "",
        participantType: ParticipantTypes.ART_CENTRE,
      },
      {
        id: "collaboration",
        label: "As a collaboration account",
        description: "",
        participantType: ParticipantTypes.COLLABORATION,
      },
    ],
    headerTitle: "I'm here to collect royalties",
  },
};

export const getParticipantOptionsAndHeader = (
  isResaleReporter: boolean,
  isRoyaltyRecipient: boolean,
  isInternalUserCreatingAccount: boolean,
) => {
  let optionsAndHeader;

  if (isResaleReporter && isRoyaltyRecipient) {
    optionsAndHeader = participantOptionsMap.resaleReporterAndRoyaltyRecipient;
  } else if (isResaleReporter) {
    optionsAndHeader = participantOptionsMap.resaleReporter;
  } else if (isRoyaltyRecipient) {
    optionsAndHeader = participantOptionsMap.royaltyRecipient;
  } else {
    return { options: [], headerTitle: "" };
  }
  if (!isInternalUserCreatingAccount) {
    optionsAndHeader.options = optionsAndHeader.options.filter(
      (option) => option.id !== "CMO" && option.id !== "agent" && option.id !== "collaboration",
    );
  }
  return optionsAndHeader;
};

export const displayParticipantTypes = (participantTypes: ParticipantTypes[]) => {
  return participantTypes
    ?.map((type: string) => {
      if (type === "AMP") {
        return "Art market professional";
      }
      if (type === "COLLABORATION") {
        return "Collaboration account";
      }
      return startCase(toLower(type));
    })
    .join(", ");
};
